/**
 * prevadi geometry na pixel v zavislosti na OL/View
 * @param coord: ol/Coordinate
 * @param map: ol/Map
 * @returns ol/Pixel
 */
export const convertCoordToPixel = (coord, map) => {
    const size = map.getSize();
    const extent = map.getView().calculateExtent(size);
    const dx = extent[2] - extent[0]; // =size[0]
    const dy = extent[3] - extent[1]; // =size[1]
    const px = coord[0] - extent[0];
    const py = coord[1] - extent[1];
    const pixelx = (px / dx) * size[0];
    const pixely = size[1] - (py / dy) * size[1];
    return [pixelx, pixely];
};
//# sourceMappingURL=convertCoordToPixel.js.map